import { useSearch } from "wouter";

export function withFromParam(url: string, from: string): string {
  if (!from || !from.startsWith("/") || from.startsWith("//")) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}from=${encodeURIComponent(from)}`;
}

export function useBackTarget(fallback: string): string {
  const search = useSearch();
  const params = new URLSearchParams(search);
  const from = params.get("from");
  if (from && from.startsWith("/") && !from.startsWith("//")) {
    return from;
  }
  return fallback;
}
